import { createTheme, PaletteMode } from "@mui/material";

export function buildTheme(mode: PaletteMode) {
  return createTheme({
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: { main: "#004ac6", light: "#b4c5ff", dark: "#003ea8" },
            secondary: { main: "#505f76" },
            error: { main: "#ba1a1a" },
            background: { default: "#faf8ff", paper: "#ffffff" },
            text: { primary: "#131b2e", secondary: "#434655" },
          }
        : {
            primary: { main: "#b4c5ff", light: "#dbe1ff", dark: "#003ea8" },
            secondary: { main: "#b7c8e1" },
            error: { main: "#ffb4ab" },
            background: { default: "#111827", paper: "#1e293b" },
            text: { primary: "#eef0ff", secondary: "#c3c6d7" },
          }),
    },
    typography: {
      fontFamily: "'Inter', sans-serif",
      h1: { fontFamily: "'Manrope', sans-serif", fontWeight: 700 },
      h2: { fontFamily: "'Manrope', sans-serif", fontWeight: 700 },
      h3: { fontFamily: "'Manrope', sans-serif", fontWeight: 600 },
      h4: { fontFamily: "'Manrope', sans-serif", fontWeight: 600 },
      h5: { fontFamily: "'Manrope', sans-serif", fontWeight: 600 },
      h6: { fontFamily: "'Manrope', sans-serif", fontWeight: 600 },
    },
    shape: { borderRadius: 8 },
    components: {
      MuiButton: {
        styleOverrides: {
          root: { textTransform: "none", fontWeight: 600 },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: { borderRadius: 12 },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            borderRight: "1px solid",
            borderColor: mode === "light" ? "#e2e8f0" : "#334155",
          },
        },
      },
    },
  });
}
